import { MessagingTopology } from '@internal/open-catalog';
import React, { ChangeEvent, useState } from 'react';
import { OutputTargetPanel } from './panel.output.target';
import { SelectedPanel } from './panel.selected';

export function OutputToolbar(props: {
  data: any,
  topology: MessagingTopology,
  onTopologyChange: (newNodeName?: string) => void
}) {

  const { data, topology, onTopologyChange } = props;

  const [expanded, setExpanded] = useState<string>('targets');

  const handleAccordionStateChange = (panel: any) => (_event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (<>
    <SelectedPanel data={data} icon={data.icon} />
    <OutputTargetPanel
      topology={topology}
      expanded={expanded}
      onAccordionStateChange={handleAccordionStateChange}
      onTopologyChange={onTopologyChange} />
  </>);
}
